import React from 'react'
import { ReactComponent as Logo } from '@/shared/assets/logo_7blaze.svg'

import cls from './footer.module.scss'

export const Footer = () => {
    return (
        <div className={cls.wrapper}>
            <footer className={cls.Footer}>
                <p>© 2025 7stellar. All rights reserved</p>
                <Logo
                    onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
                    className={cls.Logo}
                />
            </footer>
        </div>
    )
}
